import {
    CHECKOUT_SUBMIT,
    CHECKOUT_SUBMIT_ERROR,
    CHECKOUT_SET_DISCOUNT_CODE,
    CHECKOUT_SET_PURCHASE_ORDER_NUMBER,
    CHECKOUT_SET_DELIVERY,
    CHECKOUT_SET_PAYMENT,
    CHECKOUT_ACCEPT_TERMS,
    CHECKOUT_SET_PAYMENT_WIDGET,
    CHECKOUT_SET_EDITING_CUSTOMER_DETAILS,
    CHECKOUT_SET_COUNTRY,
    CHECKOUT_SET_USED_DISCOUNT_CODE,
    CHECKOUT_UPDATE_CUSTOMER_INFO,
    CLEAR_ERROR,
    CHECKOUT_SET_SHIPPING_OPTION,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    payload: {
        paymentWidget: null,
        shipmentWidget: null,
        deliveryMethods: [],
        paymentMethods: [],
        selectedCountry: {},
        selectedDeliveryMethod: {},
        selectedPaymentMethod: {},
        alternativeAddress: {},
        editingCustomerDetails: true,
        customerDetails: {},
        authenticated: false,
        acceptTerms: false,
        acceptTermsText: '',
        acceptTermsCheckboxText: '',
        discountCode: '',
        usedDiscountCodes: {},
        purchaseOrderNumber: '',
        errorMessages: {},
        afterSetCustomerDetailRedirectToCountryChannelUrl: '',
        checkoutUrl: '',
        loginUrl: '',
        redirectUrl: '',
        startPageUrl: '',
        shippingInfo: '',
        isBusinessCustomer: false,
        companyAddresses: [],
    },
    errors: {},
    result: {},
    enableConfirmButton: false,
};
export const checkout = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CHECKOUT_SUBMIT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        case CHECKOUT_SUBMIT:
        case CLEAR_ERROR:
            return {
                ...state,
                ...payload,
            };
        case CHECKOUT_UPDATE_CUSTOMER_INFO:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    [payload.key]: {
                        ...state.payload[payload.key],
                        ...payload.data,
                    },
                },
            };
        case CHECKOUT_SET_DELIVERY:
        case CHECKOUT_SET_PAYMENT:
        case CHECKOUT_SET_PAYMENT_WIDGET:
        case CHECKOUT_SET_SHIPPING_OPTION:
        case CHECKOUT_SET_EDITING_CUSTOMER_DETAILS:
        case CHECKOUT_ACCEPT_TERMS:
        case CHECKOUT_SET_DISCOUNT_CODE:
        case CHECKOUT_SET_PURCHASE_ORDER_NUMBER:
        case CHECKOUT_SET_COUNTRY:
        case CHECKOUT_SET_USED_DISCOUNT_CODE:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    ...payload,
                },
            };
        default:
            return state;
    }
};
